export var DayPeriod;
(function (DayPeriod) {
    DayPeriod["ANTE"] = "AM";
    DayPeriod["POST"] = "PM";
})(DayPeriod || (DayPeriod = {}));
